<script setup lang="ts">
  import { blurhashToCssGradientString } from '@unpic/placeholder'
  import { decode } from 'blurhash'
  import { computed, onMounted, ref, watch } from 'vue'

  const props = defineProps({
    hash: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    punch: {
      type: Number,
      default: 1,
    },
  })

  const canvasRef = ref<HTMLCanvasElement | null>(null)
  const isMounted = ref(false)

  const gradientCss = computed(() => (props.hash ? blurhashToCssGradientString(props.hash) : ''))

  onMounted(() => {
    isMounted.value = true
    drawBlurhash()
  })

  watch(
    () => props.hash,
    () => {
      if (isMounted.value) drawBlurhash()
    }
  )

  function drawBlurhash() {
    const canvas = canvasRef.value
    if (!canvas || !props.hash) return

    const w = props.width ?? 32
    const h = props.height ?? 32
    const pixels = decode(props.hash, w, h, props.punch ?? 1)

    canvas.width = w
    canvas.height = h

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    const imageData = ctx.createImageData(w, h)
    imageData.data.set(pixels)
    ctx.putImageData(imageData, 0, 0)
  }
</script>

<template>
  <div
    :style="{
      backgroundImage: gradientCss,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }"
  >
    <canvas v-if="isMounted" ref="canvasRef" class="absolute inset-0 h-full w-full" />
  </div>
</template>
